import React, { Fragment } from 'react';
import {
    makeStyles,
    Theme,
    TextareaAutosize,
    Typography,
    Box,
} from '@material-ui/core';
import { IComment } from './types';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    textarea: {
        ...theme.typography.body1,
        backgroundColor: theme.palette.background.default,
        border: `solid 1px ${theme.palette.divider}`,
        color: theme.palette.text.primary,
        padding: '10px 15px',
        borderRadius: 3,
        resize: 'none',
        width: '100%',
    },
}));

export const Comments = ({
    comment,
    handleChange,
    isEditable,
    ...props
}: IComment) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box className={classes.root} {...props}>
            <Typography variant="h4" color="textPrimary">
                {t('evaluation.comment')}{' '}
            </Typography>
            <TextareaAutosize
                name="comments"
                className={classes.textarea}
                placeholder={t('evaluation.comment')}
                minRows={3}
                maxRows={3}
                onChange={handleChange}
                value={comment}
                disabled={!isEditable}
            />
        </Box>
    );
};
